"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var MainComponent = (function () {
    function MainComponent(eventService) {
        this.eventService = eventService;
    }
    MainComponent.prototype.ngOnInit = function () {
        this.subscribeOnEvents();
    };
    MainComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    MainComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionShowPacksBoxLayoutEvent = this.eventService.subscribe('showPacksBoxLayout', function () {
            _this.stateActiveLayout = true;
        });
        this.subscriptionHidePacksBoxLayoutEvent = this.eventService.subscribe('hidePacksBoxLayout', function () {
            _this.stateActiveLayout = false;
        });
    };
    MainComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionShowPacksBoxLayoutEvent.unsubscribe();
        this.subscriptionHidePacksBoxLayoutEvent.unsubscribe();
    };
    return MainComponent;
}());
MainComponent = __decorate([
    core_1.Component({
        selector: 'main-component',
        template: require('./main.component.pug'),
        styles: [require('./main.component.scss')]
    }),
    __metadata("design:paramtypes", [services_1.EventService])
], MainComponent);
exports.MainComponent = MainComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/main/main.component.ts
// module id = 244
// module chunks = 0